import { render } from "./StandardMssPreservedFormT.vue?vue&type=template&id=24a37c9c"
import script from "./StandardMssPreservedFormT.vue?vue&type=script&lang=js"
export * from "./StandardMssPreservedFormT.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__